import * as angular from 'angular';
import { SharedRegentsPrepStepComponentsModule } from './../../../shared-components/shared-regents-prep-step-components.module';
import { RegentsExamsStepperTransferComponent } from './regents-exams-stepper-transfer.component';
import { StudentReviewTransferComponent } from './steps/student-review/student-review.component';

export const RegentsExamsStepperTransferModule = angular
  .module('regentsExamsStepperTransferModule', [SharedRegentsPrepStepComponentsModule])
  .component('regentsExamsStepperTransferComponent', RegentsExamsStepperTransferComponent)
  .component('studentReviewTransferComponent', StudentReviewTransferComponent).name;
